import { Container, SceneObject } from '@cgs/wge';
import { ResourcesComponent } from '../../game/components/resources_component';
import { RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';

export const POPUP_HOLDER_COMPONENT_TOKEN = Symbol('POPUP_HOLDER_COMPONENT_TOKEN');

export interface IPopupHolderComponent {
  scene: SceneObject;
  addPopup: (popup: SceneObject) => void;
}

export class PopupHolderComponent implements IPopupHolderComponent {
  protected popupHolder: SceneObject;

  constructor(protected readonly container: Container) {
    const resourceComponent = this.container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this.popupHolder = resourceComponent.root;
  }

  public addPopup(popup: SceneObject): void {
    this.popupHolder.addChild(popup);
  }

  public get scene(): SceneObject {
    return this.popupHolder;
  }
}
